import React from 'react'
import './button.css'

function LogoutButton({name, onClickHandler, color="primary", size="small"}) {
  return (
    <button className={`logout-button`} onClick={onClickHandler}>{name}</button>
  )
}

export default LogoutButton